import * as yup from 'yup';

// biome-ignore lint/suspicious/noControlCharactersInRegex: intentional control-character matching
export default yup.string().matches(/^[\x00-\xFF]*$/, 'Please only use alphanumeric characters.');
